import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar traduções
import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';
import esES from './locales/es-ES.json';
import frFR from './locales/fr-FR.json';

const resources = {
  'pt-PT': {
    translation: ptBR
  },
  'pt-BR': {
    translation: ptBR
  },
  'en-US': {
    translation: enUS
  },
  'es-ES': {
    translation: esES
  },
  'fr-FR': {
    translation: frFR
  }
};

// Obtém idioma salvo no localStorage ou do navegador
let initialLang = 'pt-PT';
try {
  const saved = localStorage.getItem('lang');
  if (saved && resources[saved]) initialLang = saved;
  else if (typeof navigator !== 'undefined') {
    const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (nav.startsWith('pt')) initialLang = 'pt-PT';
    else if (nav.startsWith('en')) initialLang = 'en-US';
    else if (nav.startsWith('es')) initialLang = 'es-ES';
    else if (nav.startsWith('fr')) initialLang = 'fr-FR';
  }
} catch (_) {
  // Ignore errors when accessing localStorage or navigator
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang, // idioma inicial
    fallbackLng: 'pt-PT',
    saveMissing: false,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;